// extracted by mini-css-extract-plugin
export default {"wrapper":"Donate_wrapper__094wi","icon":"Donate_icon__Nqi3A"};